import { sanitizeBusinessMessage, toUserFacingApiError } from '../utils/userFacingError'
import { api } from './api'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; error?: { code?: string }; data?: unknown }
  if (!b?.success) {
    const err = new Error(sanitizeBusinessMessage(b?.message, 'Request failed')) as Error & { code?: string }
    err.code = b.error?.code
    throw err
  }
  return b.data
}

function apiError(err: unknown, fallback: string) {
  return toUserFacingApiError(err, fallback)
}

export type DashboardSalesStats = {
  storeId: number
  currency: string
  ordersLast7Days: number
  ordersLast30Days: number
  revenueLast7Days: number
  revenueLast30Days: number
  pendingFulfillmentCount: number
  hasActivity: boolean
}

export async function fetchDashboardSalesStats(storeId?: number): Promise<DashboardSalesStats> {
  try {
    const { data } = await api.get('/storebusiness/dashboard/sales-stats', {
      params: storeId != null ? { storeId } : undefined,
    })
    return assertSuccess(data) as DashboardSalesStats
  } catch (e) {
    throw apiError(e, 'Failed to load dashboard stats')
  }
}
